// 是否是本地开发环境
export const isDev =
  location.href.indexOf('http://localhost') === 0 ||
  location.href.indexOf('http://192.168.0.160:8080') === 0 ||
  location.href.indexOf('http://127.0.0.1') === 0;

// 是否是测试环境
export const isTesting = location.href.indexOf('gov-h5.p.kf315.net') >= 0;
// 是否是生产环境
export const isProduction = !(isDev || isTesting);
// 测试环境设置
const testConfig = {};

// 本地开发设置
const devConfig = {};
// 生产环境设置
const productionConfig = {};
let config = {};
if (isDev) {
  config = devConfig;
} else if (isTesting) {
  config = testConfig;
} else if (isProduction) {
  config = productionConfig;
}
const finalConfig = {
  ...config,
};

export { finalConfig };
